import React, { createContext, useContext, ReactNode } from 'react'
import { useCookieConsent, ConsentState } from '../hooks/useCookieConsent'

interface CookieConsentContextValue {
    consent: ConsentState
    analyticsAllowed: boolean
    accept: () => void
    reject: () => void
    showBanner: boolean
}

const CookieConsentContext = createContext<CookieConsentContextValue>({
    consent: 'undecided',
    analyticsAllowed: false,
    accept: () => {},
    reject: () => {},
    showBanner: false,
})

export const CookieConsentProvider: React.FC<{ children: ReactNode }> = ({
    children,
}) => {
    const value = useCookieConsent()
    return (
        <CookieConsentContext.Provider value={value}>
            {children}
        </CookieConsentContext.Provider>
    )
}

export const useCookieConsentContext = () => useContext(CookieConsentContext)
